import { fetchSavedFilters, fetchSavedFilterDetail, createSavedFilter, updateSavedFilter, deleteSavedFilter, fetchAccessGrants, setAccessGrant } from '../api/filterApi';
export async function getFilters(entityType, application) {
    return fetchSavedFilters(entityType, application);
}
export async function getFilterDetail(id) {
    return fetchSavedFilterDetail(id);
}
export async function saveFilter(body) {
    return createSavedFilter(body);
}
export async function saveFilterChanges(id, body) {
    return updateSavedFilter(id, body);
}
export async function removeFilter(id) {
    return deleteSavedFilter(id);
}
export async function getAccessGrants(id) {
    return fetchAccessGrants(id);
}
export async function putAccessGrant(id, body) {
    return setAccessGrant(id, body);
}
